


/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {LinksData} from '../../core/_models'
import { stat } from 'fs'

type Props = {
  linksData: LinksData
}
const status ={
   '200' :  'badge badge-light-success fs-8 fw-bold',
   '404' : 'badge badge-light-danger fs-8 fw-bold',
   '503' : 'badge badge-light-warning fs-8 fw-bold' 
}
const ScrappingStatuCell: FC<Props> = ({linksData}) => {
 
 return (
 <>
 
 <span className={`${status[linksData?.status as keyof typeof status || '']}`}>{linksData.status}</span>
 </>
 );

}




export {ScrappingStatuCell,}

